( function( $ ) { // opens document ready

	/* search form text dissappearance when clicking in the text field
	 * http://kneedeepincode.com/topics/making-a-dynamic-jquery-search-box/
	 */

	/* Function to add Colorbox pop up to various links */

	function colorboxLinks() {
		var windowWidth = $( window ).width();
		var galleryImgItems = $( '.has-nested-images .wp-block-image a[href$=".jpg"], .has-nested-images .wp-block-image a[href$=".png"], .has-nested-images .wp-block-image a[href$=".gif"], .blocks-gallery-item a[href$=".jpg"], .blocks-gallery-item a[href$=".png"], .blocks-gallery-item a[href$=".gif"], .gallery-icon a[href$=".jpg"], .gallery-icon a[href$=".png"], .gallery-icon a[href$=".gif"]' );
		var galleryAttsItems = $( '.has-nested-images > figure > a:not([href$=".jpg"], [href$=".png"], [href$=".gif"]), .blocks-gallery-item > figure > a:not([href$=".jpg"], [href$=".png"], [href$=".gif"]), .gallery-icon > a:not([href$=".jpg"], [href$=".png"], [href$=".gif"])' );

		// For galleries that link to images
		if ( windowWidth < 640 ) {
			galleryImgItems.colorbox({
				rel: 'gallery',
				maxWidth: '100%',
				maxHeight: '75%'
			});
		} else {
			galleryImgItems.colorbox({
				rel: 'gallery',
				maxWidth: '75%',
				maxHeight: '75%'
			});
		}
		//console.log(galleryImgItems);

		// For galleries that link to attachment pages
		if ( windowWidth < 640 ) {
			galleryAttsItems.colorbox({
				rel: 'gallery',
				iframe: 'true',
				height: '75%',
				width: '100%'
			});
		} else {
			galleryAttsItems.colorbox({
				rel: 'gallery',
				iframe: 'true',
				height: '75%',
				width: '75%'
			});
		}
		//console.log(galleryAttsItems);
	}

	// disable scrolling on parent document
	$(document).on( 'cbox_open', function() {
		$( 'body' ).css({ overflow: 'hidden' });
	}).on( 'cbox_closed', function() {
		$( 'body' ).css({ overflow: 'auto' });
	});

	function socialMediaButtons() {
		var socialContainer = document.querySelector( '#social-menu' );

		/* add social media icons to links in the Social Media Icons menu */
    /* by adding specific classes to a tags with *.com strings */

		// Check if the social icons container exists
		if (document.body.contains(socialContainer)) {
			var fbLink = document.querySelector('#social-menu__list li a[href*="facebook.com"]');
			var twLink = document.querySelector('#social-menu__list li a[href*="twitter.com"]');
			var instLink = document.querySelector('#social-menu__list li a[href*="instagram.com"]');
			var pntLink = document.querySelector('#social-menu__list li a[href*="pinterest.com"]');
			var ytLink = document.querySelector('#social-menu__list li a[href*="youtube.com"]');
			var gthbLink = document.querySelector('#social-menu__list li a[href*="github.com"]');
			var wpOrgLink = document.querySelector('#social-menu li a[href*="wordpress.org"]');

			if (fbLink) {
				fbLink.classList.add('fab', 'fa-facebook-square');
			}
			if (twLink) {
				twLink.classList.add('fab', 'fa-twitter-square');
			}
			if (instLink) {
				instLink.classList.add('fab', 'fa-instagram-square');
			}
			if (pntLink) {
				pntLink.classList.add('fab', 'fa-pinterest-square');
			}
			if (ytLink) {
				ytLink.classList.add('fab', 'fa-youtube-square');
			}
			if (gthbLink) {
				gthbLink.classList.add('fab', 'fa-github-square');
			}
			if (wpOrgLink) {
				wpOrgLink.classList.add('fab', 'fa-wordpress');
			}
		}
	}

	function jgdInitScripts() {
		colorboxLinks();
		socialMediaButtons();
	}
	document.addEventListener( 'DOMContentLoaded', jgdInitScripts );

} ) (jQuery); // closes document ready
